import { omniaDefer, OmniaDefer } from "../promises"
import { isDefined, isNumber } from "../utils/utils"
import { Component } from "./component"
import { Module } from "./module"
import { IComponentContext, IComponentDefinition, IComponentStartOptions } from "./types"

/** @internal */
export class ComponentContext implements IComponentContext {

    private _def: IComponentDefinition;
    private _result: OmniaDefer<any>;
    private _component: Component;

    public isPinned: boolean = true;

    constructor(private _options: IComponentStartOptions, private module: Module, public readonly modal: boolean) {

        this._def = module.getComponentDefinition(_options.component);

        if (!this._def) {
            throw Error("Unknown component: " + (this._options.component || ""));
        }

    }

    get component(): Component {
        return this._component;
    }

    set component(value: Component) {
        this._component = value;
    }

    get directive(): string {
        return this._def.directive;
    }

    get reactComponent() {
        return this._def.reactComponent
    }

    get width() {
        let w = this._component ? this._component.width : null;
        w = isNumber(w) ? w : this._def.width;
        return w;
    }

    get attrs(): { [key: string]: string } {
        return this._def.attrs;
    }

    get execArguments(): any {
        return this._options.execArguments;
    }

    get options(): IComponentStartOptions {
        return this._options;
    }

    get result(): ng.IPromise<any> {

        if (!this._result) {
            this._result = omniaDefer();
        }

        return this._result.promise;

    }

    get visible(): boolean {
        return (this._def.visible ? this._def.visible() : true);
    }

    isActive(): boolean {
        return this.module.isActive(this);
    }

    canClose(): boolean {
        return this.module.canClose(this);
    }

    startComponent(options: IComponentStartOptions): IComponentContext {

        const def = this.module.getComponentDefinition(options.component);

        const restart: boolean = isDefined(options.restartCurrent) ? options.restartCurrent : (def ? def.restartCurrent : false);
        const refresh = def.refreshOnClose

        const ctxt = this.module.startComponent(options, restart);

        if (restart || refresh) {

            ctxt.result.then(r => {

                if (restart) {
                    ctxt.startComponent(this._options);
                }

                if (refresh) {
                    return this.module.refresh(true).then(_ => r)
                }

                return r

            })

        }



        return ctxt;

    }

    pin(): void {
        this.isPinned = !this.isPinned;
    }

    close(result?: any) {

        this.module.closeComponent(this)

        if (this._result) {
            this._result.resolve(result)
        }

    }
}
